@let f = form();
<div class="pt-16">
    <div class="grid grid-cols-1 gap-x-[50px] gap-y-16 lg:grid-cols-2">
        @let wishDateCtr = f.controls.wishDate;
        <ui-m020-c080-input-datepicker
            [control]="wishDateCtr"
            [disabledWeekDays]="[0]"
            [disabledDays]="holidays()"
            [minDate]="minDate()"
            [maxDate]="maxDate()"
            [error]="wishDateCtr.touched && wishDateCtr.invalid"
            (click)="trackingStart()"
        >
            Wunschtermin
        </ui-m020-c080-input-datepicker>

        <ui-input-select
            [formControl]="f.controls.wishTime"
            [options]="[
                {
                    label: 'Vormittags',
                    value: 'Vormittags',
                },
                {
                    label: 'Nachmittags',
                    value: 'Nachmittags',
                },
                {
                    label: 'Beliebige Tageszeit',
                    value: 'Beliebige Tageszeit',
                },
            ]"
            (click)="trackingStart()"
            label="Gewünschte Tageszeit"
            withNullSelect
        />

        <div class="lg:col-span-2">
            <ui-input-textarea
                [formControl]="f.controls.message"
                [defaultHeight]="110"
                (click)="trackingStart()"
                label="Ihre Nachricht"
                placeholder="Schreiben Sie etwas... (optional)"
            />
        </div>
    </div>

    <lib-distribution-contact-template
        [form]="f"
        [errorMsg]="errorMsg()"
        (formClicked)="trackingStart()"
        (submitClicked)="submitClicked.emit()"
    />
</div>
